import { useEffect, useRef, useState } from "react"
import { View } from "@react-three/drei"
import TextPart from "./components/TextPart"
import Service from "./components/Service"
import Video from "./components/lastProject/Video"


export default function ContentSection() {
    const [playing, setPlaying] = useState(false)
    const ref = useRef()

    useEffect(() => {
        const el = ref.current
        if (!el) return

        const firstP = el.querySelector('.track > p')
        if (!firstP) return

        const updateWidth = () => {
            const width = firstP.offsetWidth
            el.style.setProperty('--w', `${width}px`)
        }

        updateWidth()
        window.addEventListener('resize', updateWidth)
        document.fonts?.ready?.then(updateWidth)

        return () => window.removeEventListener('resize', updateWidth)
    }, [])

    return (
        <section className="content-section">
            <TextPart />
            <div className="dernier-projet dernier-projet-top f48" ref={ref}>
                <p>LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN •</p>
                <p>LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN •</p>
            </div>
            <div className={`video-container ${playing ? 'playing' : 'pause'}`}>
                <div className="player f16" onClick={() => setPlaying(p => !p)}>
                    <img src="./img/play.svg" alt="Icon play video" />
                    <img className="pause-img" src="./img/pause.svg" alt="Icon pause video" />
                </div>
                <View className="view video-view" >
                    <Video playing={playing} />
                </View>
            </div>
            <div className="dernier-projet dernier-projet-bottom f48">
                <p>LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN •</p>
                <p>LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN • LE DERNIER PROJET • LINEUP OCEAN •</p>
            </div>
            <Service />
        </section>
    )
}